var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","d":"M11.229,11.229c-1.583,1.582-3.417,3.096-4.142,2.371c-1.037-1.037-1.677-1.941-3.965-0.102\n\tc-2.287,1.838-0.53,3.064,0.475,4.068c1.16,1.16,5.484,0.062,9.758-4.211c4.273-4.274,5.368-8.598,4.207-9.758\n\tc-1.005-1.006-2.225-2.762-4.063-0.475c-1.839,2.287-0.936,2.927,0.103,3.965C14.324,7.812,12.811,9.646,11.229,11.229z"}));
}

IconPhone.defaultProps = {"version":"1.1","id":"Phone","x":"0px","y":"0px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","xmlSpace":"preserve"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
